//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {ServicesSearch} from '@/modules/ServicesSearch';
import nomenclatoare from '@/store/nomenclatoare';
import {getModule} from 'vuex-module-decorators';
const storeNomenclatoare = getModule(nomenclatoare);
export default {
    name: 'StatusNumere',
    data: ()=>{
        return{
            loadingData:false,
            arrStatusNumere:[]
        }
    },
    methods:{
      getStatusNumere(){
          const vueInst = this;
          ServicesSearch.getStatusNumere().then(presponse=>{
              vueInst.loadingData=false;
              if(presponse.status=='success'){
                  vueInst.arrStatusNumere = JSON.parse(JSON.stringify(presponse.rows));
              }
          })
      }
    },
    mounted(){
        const vueInst = this;
        vueInst.loadingData=true;
        storeNomenclatoare.set_currentpagetitle('Status Numere');
        vueInst.getStatusNumere();
    }
}
